export const name = 'ks/customer';
